import { useLayout } from '@/hooks/useLayout';

/**
 * Smart footer component that automatically positions itself
 * based on whether the current page has a sidebar
 */
export function Footer() {
  const { hasSidebar, sidebarCollapsed } = useLayout();

  return (
    <div
      className={`fixed bottom-0 right-0 px-4 py-3 bg-background/80 backdrop-blur-sm border-t ${
        hasSidebar ? (sidebarCollapsed ? 'left-20' : 'left-64') : 'left-0'
      }`}
    >
      <div className="text-sm text-muted-foreground text-center">
        <a
          href="mailto:support@knostic.ai"
          className="text-primary hover:underline"
        >
          Contact us
        </a>{' '}
        for support.
      </div>
    </div>
  );
}
